import { ThirdPartyModel } from "@models/thirdparty/ThirdpartyModel";
import { Input, Component, OnInit, inject } from "@angular/core";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { ContactModel } from "@models/thirdparty/ContactModel";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/thirdparty/i18n/scope";

@Component({
    selector: "thirdparty-contacts",
    templateUrl: "thirdparty-contacts.component.html",
    styleUrls: ["thirdparty-contacts.component.scss"],
    imports: [GenericListManagerComponent],
})
export class ThirdPartyContactsComponent implements OnInit {
    private _promptService = inject(CerrixPromptService);
    private _translation = injectTranslation(scope);

    @Input() thirdParty: ThirdPartyModel;
    @Input() canEdit: boolean;

    contactConfig: GenericListConfig;

    async ngOnInit() {
        await this._translation.ready();
        this.initContactsConfig();
    }

    initContactsConfig() {
        this.contactConfig = <GenericListConfig>{
            idProp: "id",
            uiidAdd: "thirdpartycontacts-addbutton",
            name: this._translation.t("contacts.listName"),
            isSortable: true,

            allowAdd: this.canEdit,
            allowDelete: this.canEdit,
            allowEdit: this.canEdit,

            data: this.thirdParty.Contacts,
            fields: [
                {
                    fieldName: "name",
                    prettyName: this._translation.t("contacts.nameField"),
                    uiid: "thirdpartycontacts-name",
                    required: true,
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: "role",
                    prettyName: this._translation.t("contacts.roleField"),
                    uiid: "thirdpartycontacts-role",
                    fieldType: GenericListFieldType.Text,
                    editorWidth: "12",
                },
                {
                    fieldName: "phone",
                    prettyName: this._translation.t("contacts.phoneField"),
                    uiid: "thirdpartycontacts-phone",
                    fieldType: GenericListFieldType.Phone,
                    maxLength: 13,
                },
                {
                    fieldName: "email",
                    prettyName: this._translation.t("contacts.emailField"),
                    uiid: "thirdpartycontacts-email",
                    fieldType: GenericListFieldType.Email,
                },
            ],

            delete: async (row: ContactModel) => {
                return await this._promptService
                    .confirm(
                        this._translation.t("contacts.deleteTitle"),
                        this._translation.t("contacts.deleteMessage"),
                    )
                    .toPromise();
            },
        };
    }
}
